<template>
  <table-list
      ref="list"
      @query="handleLoadList"
      :request-params="{userNum: $route.query.num}"
      :data="tableData"
      v-bind="$attrs">
    <el-table-column align="center" :label="$t('评论编号')" prop="num" />
    <el-table-column align="center" prop="dynamicsNum" :label="$t('动态编号')" />
    <el-table-column align="center" prop="dynamicsContent" :label="$t('动态内容')" />
    <el-table-column align="center" prop="content" :label="$t('评论内容')" />
    <el-table-column align="center" :label="$t('评论时间')">
      <template v-slot="{row}">{{ row.createTime | formatDate }}</template>
    </el-table-column>
  </table-list>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request} from "@/config/request";
export default {
  name: "DynComments",
  components: {TableList},
  props: {
    tabCurrent: {
      type: String,
      default: ""
    },
    current: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tableData: []
    }
  },
  methods:  {
    async handleLoadList(params, setTotal) {
      try {
        let res = await request(this.$api.dynamicsComment.list, params);
        for (const key in res) {
          if(Array.isArray(res[key])) {
            this.tableData = res[key];
          }
        }
        setTotal(res.pager.itemCount);
      }catch(e) {
        console.log(e);
      }
    }
  },
  watch: {
    current: {
      handler(val) {
        if(val === this.tabCurrent) {
          this.$nextTick(() => {
            this.$refs.list.handleRequest();
          })
        }
      },
      immediate: true,
    }
  }
}
</script>

<style scoped>

</style>